module.exports = __webpack_public_path__ + "static/media/slide-modal-image.0f54f49b.webp";